import 'moment/locale/th'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import Router from './components/Router'
import './i18n'
import configureStore from './store'

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <Provider store={configureStore()}>
        <Router />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
)
